import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../../app/app.service';
import { OrdinalDateParse } from '../adapters/ordinal-date-adapter';
import { ContractorsVM, Department, WorkArea } from '../entities/global/model';
import { ChecklistCategory, ChecklistQuestion, InspectionSearchResultsVM, SafetyInpsectionSearchVM, SearchByParametersSafetySearchVM, StateVM } from '../perform-induction/perform-induction';
import { SafetyInductionService } from '../services/safety-induction.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { SelectionLists } from '../../../entities';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-search-safety-inspection',
  templateUrl: './search-safety-inspection.component.html',
  styleUrls: ['./search-safety-inspection.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class SearchSafetyInspectionComponent implements OnInit {

  constructor(private _appService: AppService,
     private _inductionService: SafetyInductionService,
    private _router:Router,) {

  }

  endDate: Date = new Date();
  startDate: Date = new Date(new Date().setDate(new Date().getDate() - 7));

  SeachFormData: SafetyInpsectionSearchVM;

  selectedDepartment:number[]=[];
  DepartmentList: Department[];
  selectedCategory:number[]=[];
  CategoryList:ChecklistCategory[];
  ContractorList:ContractorsVM[];
  selectedContractor:string[] =[];
  WorkAreaList:WorkArea[];
  selectedWorkArea:number[]=[];
  selectedQuestion:number[]=[];
  selectedCustomer:number[]=[];
  QuestionList:ChecklistQuestion[];
  StateList:StateVM[];
  selectedState:number[]=[];
  FollowUpReq:boolean=false;
  FollowUpComp:boolean=false;
  OnlyUnsafe:boolean=false;
  ExcludeNA:boolean=false;
  OnlyInsp:boolean=true;
  SearchResult:InspectionSearchResultsVM[]=[];
  isLoading:boolean=false;
  nodata:boolean=false;

  dataSource = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  //displayedColumns = [];
  ord: OrdinalDateParse = new OrdinalDateParse();
  DefaultWorkAreaList:WorkArea[];
  DefaultDepartmentList:Department[];
  DefaultWorkAreaList_:WorkArea[];
  shwOb:boolean=false;
  shwDep:boolean=true;
  shwWA:boolean=true;
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
displayedColumns = ['CompletedDate', 'Department', 'WorkArea', 'Category', 'Question', 'SafeOrUnsafe', 'Observer'];
  

  
   
  ngOnInit() {
    this._appService.setPageTitle('Safety Observation Search');

    this.dataSource.sort = this.sort;
    this.displayedColumns = ['CompletedDate', 'Department', 'WorkArea', 'Category', 'Question', 'SafeOrUnsafe'];
    this.LoadSearchDate();
   // this.endDate = new Date();
    //this.startDate = new Date(new Date().setDate(new Date().getDate() - 7));

    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.customerList = result;
        this._dropDownListsFiltered.customerList = result;
        console.log( " this._dropDownLists.customerList ",this._dropDownLists.customerList )
      },
      error => {
        console.error(error);
      },
      () => {
        
      }
    );
  }
  DepChange(depId){
    let wr = this.DefaultWorkAreaList_
    let tempArr :WorkArea[]=[];
    if(depId.value.length >0){
    
      depId.value.map(m=>{
        if(m){
          let _workA = wr.filter(d=>d.DepartmentID == m && d.Active==true)
          console.log("_workAfiltered by dep",_workA)
          if(_workA){
            tempArr=tempArr.concat(_workA)
          }
          
        }
      })
    
    }
   // this.WorkAreaList = tempArr

    
    this.WorkAreaList=tempArr.sort(function(a, b){
      if(a.WorkAreaName < b.WorkAreaName) { return -1; }
      if(a.WorkAreaName > b.WorkAreaName) { return 1; }
      return 0;
  })
    
    console.log("dep cha",this.WorkAreaList)

  }
  SiteChange(siteId){
console.log("this.WorkAreaList",this.WorkAreaList)
console.log("this.DepartmentList",this.DepartmentList)
console.log("siteId",siteId.value)

let wr = this.DefaultWorkAreaList
let tempArr :WorkArea[]=[];
if(siteId.value.length >0){

  siteId.value.map(m=>{
    if(m){
      let _workA = wr.filter(d=>d.SiteId == m &&d.Active==true)
      console.log("_workA",_workA)
      if(_workA){
        tempArr=tempArr.concat(_workA)
      }
      
    }
  })

}
//this.WorkAreaList = tempArr
this.WorkAreaList=tempArr.sort(function(a, b){
  if(a.WorkAreaName < b.WorkAreaName) { return -1; }
  if(a.WorkAreaName > b.WorkAreaName) { return 1; }
  return 0;
})

let dp = this.DefaultDepartmentList
let tempArrDep :Department[]=[];
if(siteId.value.length >0){

  siteId.value.map(m=>{
    if(m){
      let _dep = dp.filter(d=>d.SiteId == m)
      console.log("depa",_dep)
      if(_dep){
        tempArrDep=tempArrDep.concat(_dep)
      }
      
    }
  })

}
//this.DepartmentList = tempArrDep
this.DepartmentList=tempArrDep.sort(function(a, b){
  if(a.DepartmentName < b.DepartmentName) { return -1; }
  if(a.DepartmentName > b.DepartmentName) { return 1; }
  return 0;
})

  }

  LoadSearchDate() {
    this._inductionService.GetSafetyInspectionSearch().subscribe(res => {
      this.SeachFormData = res;
      this.DepartmentList = res.departments;
      this.CategoryList = res.categories;
      this.ContractorList = res.contractors;
      this.WorkAreaList = res.workArea;
      this.DefaultWorkAreaList = res.workArea;
      this.QuestionList = res.questions;
      this.StateList = res.States;
      this.DefaultDepartmentList=res.departments;
      this.DefaultWorkAreaList_ = res.workArea;

    })
  }


  SearchInspections(){
    let _StartDate =this.startDate? this.ord.formatDateOrdinal((this.startDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false):this.startDate;
    let _EndDate = this.endDate?this.ord.formatDateOrdinal((this.endDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false):this.endDate;
this.isLoading = true;
    let params = new SearchByParametersSafetySearchVM();
    params.DateCompletedEnd = _EndDate // moment(this.endDate).format('MM/DD/YYYY')
    params.DateCompletedStart =_StartDate //moment(this.startDate).format('MM/DD/YYYY')
    params.DateCompletedEnd_ = _EndDate;
    params.DateCompletedStart_ =_StartDate
    params.Departments = this.selectedDepartment
    params.WorkAreas = this.selectedWorkArea
    params.ChecklistQuestions = this.selectedQuestion
    params.ChecklistCategories = this.selectedCategory
    params.Contractors = this.selectedContractor
    params.States = this.selectedState

    params.FollowUpRequired = this.FollowUpReq
    params.FollowUpCompleted = this.FollowUpComp
    params.OnlyUnsafe = this.OnlyUnsafe
    params.OnlyInspections=this.OnlyInsp
    params.ExcludeNA=this.ExcludeNA
    params.selectedCustomerId=this.selectedCustomer

    console.log("params",params)
    this._inductionService.SearchByParametersForSafetyInspectionSearch(params).subscribe(res=>{
      console.log("result", res)
      this.SearchResult = res;
      this.dataSource.data = res;

      if(this.SearchResult.length==0){
        this.nodata=true;
      }else this.nodata=false;

      this.isLoading=false;
    })
  }
  
  ResetFields()
  {
    this.endDate = new Date();
    this.startDate = new Date(new Date().setDate(new Date().getDate() - 7));
    this.selectedDepartment = [];
    this.selectedCategory=[];
    this.selectedQuestion=[];
    this.selectedState=[];
    this.selectedWorkArea=[];
    this.selectedContractor = [];
    this.FollowUpReq=false;
    this.FollowUpComp=false;
    this.OnlyUnsafe=false;
    this.ExcludeNA=false;
    this.OnlyInsp=false;
    this.dataSource.data=[];
    this.displayedColumns = ['CompletedDate', 'Department', 'WorkArea', 'Category', 'Question', 'SafeOrUnsafe'];
    this.shwOb=false;
    this.shwDep=true;
    this.shwWA=true;
    this.selectedCustomer=[];
  }

  onClickOpenInspection(Inspetion:InspectionSearchResultsVM){
    this._router.navigate(['/inspection/index',Inspetion.DetailsId]);
  }


  changeCheckbox(value: boolean, key, index: number) {
    if (value === false) {
      this.removeArrayelement(this.displayedColumns, key)
    } else {
      this.displayedColumns.splice(index, 0, key)
    }
  }
  removeArrayelement(arr, key) {
    let a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
      key = a[--L];
      while ((ax = arr.indexOf(key)) !== -1) {
        arr.splice(ax, 1);
      }
    }
    return arr;
  }
  
  DownloadCSVFile(){
this.downloadFile(this.dataSource)
  }

  //download csv file
  downloadFile(data: any) {
    console.log("data", data)
    let _data = []
    data.filteredData.map(p => {
      let _o = {}
      for (var key in p) {
        if (p.hasOwnProperty(key)) {

          if(key == "CompletedDate"){
            _o["Completed Date"] = p[key]
          }else if(key == "Department"){
            _o["Department"] = p[key]
          }else if(key == "WorkArea"){
            _o["Work Area"] = p[key]
          }else if(key == "Observer"){
            _o["Observer"] = p[key]
          }else if(key == "Question"){
            _o["Question"] = p[key]
          }else if(key == "SafeOrUnsafe"){
            _o["SafeOrUnsafe"] = p[key]
          }else if(key == "Category"){
            _o["Category"] = p[key]
          }
        }
    }

    _data.push(_o)
    })

    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(_data[0]);
    let csv = _data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');
    var a = document.createElement('a');
    var blob = new Blob([csvArray], { type: 'text/csv' }),
      url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = `Safety Observation.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

}
